import axios, {AxiosRequestConfig} from 'axios';
import {store} from 'Redux/Store';
import moment from 'moment';
import * as ErrorActions from 'Redux/Actions/ErrorActions';
import * as UserActions from 'Redux/Actions/UserActions';
import * as ViewManagementActions from 'Redux/Actions/ViewManagementActions';
import * as ErrorEnumTypes from 'Models/EnumTypes/ErrorEnumTypes';
import i18n from './../Translations/_i18n';

export type QueryParams = {
    key: any;
    value: any;
};

export const baseURL = process.env.REACT_APP_baseURL;
export const appURL = process.env.REACT_APP_appURL;

if (!['development', 'test'].includes(process.env.NODE_ENV)) {
    console.log = () => {
        //remove logs
    };
}

const axiosInstance = axios.create({
    baseURL: `${baseURL}`
});
export const activeToken = store.getState().userStore.token ? store.getState().userStore.token : localStorage.getItem('token');

axiosInstance.defaults.headers.common['Authorization'] = `bearer ${activeToken}`;
axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';

function handleConfigInterCeptor(configRq: AxiosRequestConfig) {
    store.dispatch(ErrorActions.clearErrorStore());
    store.dispatch(ErrorActions.setRequestConfig(configRq));
    store.dispatch(UserActions.checkIfTokenIsNotExpired());
    return configRq;
}

function handleInterceptorError(error: any) {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
        store.dispatch(ErrorActions.unauthorizedUser());
    }
    if (error.response) {
        store.dispatch(ErrorActions.setResponseError(error.response ? error.response : error));
    } else {
        store.dispatch(ErrorActions.setResponseError(error.response ? error.response : error, true));
    }
    if (error.response && error.response.status === 401) {
        store.dispatch(ErrorActions.setNewsForMoment({
            type: ErrorEnumTypes.EnumTypes.NewsType.ERROR,
            message: i18n.t('dictionary:LOGIN_ERROR_MESSAGE')
        }));
    }
    store.dispatch(ViewManagementActions.hideLoader());
    return Promise.reject(error);
}

axiosInstance.interceptors.request.use((configRq: AxiosRequestConfig) => handleConfigInterCeptor(configRq), error => handleInterceptorError(error));

axiosInstance.interceptors.response.use(
    response => {
        store.dispatch(ErrorActions.requestSuccess(response));
        return response;
    },
    error => handleInterceptorError(error)
);

export const config = (params?: any) => {
    const configRq = {};
    if (params) {
        configRq['params'] = params;
    }
    return configRq;
};

export function createSerachQuery(params: Object | Array<Object>): URLSearchParams {
    const searchQuery = new URLSearchParams();
    if (!Array.isArray(params)) {
        Object.keys(params).forEach((e, i) => {
            if (e === 'dateRange') {
                const startDate = params[e]['startDate'].startOf('day');
                const endDate = params[e]['endDate'].isSame(moment(), 'day') ? moment() : params[e]['endDate'].endOf('day');
                searchQuery.set('startDate', startDate.format());
                searchQuery.set('endDate', endDate.format());
            } else if (e === 'dateRangeFromTo') {
                const startDate = params[e]['startDate'].startOf('day');
                const endDate = params[e]['endDate'].isSame(moment(), 'day') ? moment() : params[e]['endDate'].endOf('day');
                searchQuery.set('from', startDate.format());
                searchQuery.set('to', endDate.format());
            } else if (e === 'forDate') {
                searchQuery.set(e, params[e].isValid() ? params[e].format('YYYY-MM-DD') : '');
            } else {
                searchQuery.set(e, params[e]);
            }
        });
    } else {
        params.forEach((el, i) => {
            if (el['id'].includes('&')) {
                const names = el['id'].split('&');
                names.forEach((name, nameI) => {
                    el['value'][name].map((splittedvalue, idx) => {
                        searchQuery.append(name, splittedvalue);
                    });
                });
            } else if (Array.isArray(el['value'])) {
                el['value'].forEach((elValue, idx) => {
                    searchQuery.append(el['id'], elValue);
                });
            } else {
                if (el['value'] === 'ASCENDING' || el['value'] === 'DESCENDING') {
                    searchQuery.set('sortField', el['id'].replace(/^sort_/g, ''));
                    searchQuery.set('sortOrder', el['value']);
                } else {
                    searchQuery.set(el['id'], el['value']);
                }
            }
        });
    }
    return searchQuery;
}

export const axiosCancelToken = axios.CancelToken;

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/Connectors/_main.ts